export default __webpack_public_path__ + "2a9e905.png";